import React from "react";
import { Route, Redirect } from "react-router-dom";
// import { getToken } from "../auth";

const PrivateRoute = ({ component: Component, ...rest }: any) => {
  //   var token = getToken();
  var token = true;
  return (
    <Route
      {...rest}
      render={(props) =>
        token ? <Component {...props} /> : <Redirect to="/" />
      }
    />
  );
};

export default PrivateRoute;
